export default "__VITE_ASSET__4627557e__"